import './App.css';
import Footer from './CommonComponents/Footer';
import Navbar from './CommonComponents/Navbar';
import ContactPage from './Pages/ContactPage';
import Homepage from './Pages/HomePage';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Resources from './Pages/Resources';
import WhyTnsSabre from './Pages/WhyTnsSabre';
// import Webinar from './Pages/Webinar';
// import Blogs from './Pages/Blogs';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import WhatsappButton from './CommonComponents/WhatsappButton';

function App() {
  return (
    <>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
      />
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/why-tns-sabre" element={<WhyTnsSabre />} />
        {/* <Route path="/webinar" element={<Webinar />} />
        <Route path="/blogs" element={<Blogs />} /> */}
      </Routes>
      <Footer />
      <WhatsappButton/>
    </Router>
    </>
  );
}

export default App;

